<template>
  <div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card" style="height: 655px">
            <!-- Card header -->
            <div class="card-header py-3">
              <div class="d-lg-flex align-items-center row">
                <div class="col-4">
                  <input
                    v-model="table.search"
                    class="form-control rounded-pill text-center"
                    type="text"
                    placeholder="Search Material Type"
                    @keyup="filter"
                  />
                </div>
              </div>
            </div>
            <!-- Card Body -->
            <div class="table-responsive" style="height: 500px">
              <table v-if="!table.onLoad" class="table">
                <thead class="table-primary">
                  <tr>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Vendor Number
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Vendor Name
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Contact Person
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Email
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Phone
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Address
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      City
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Country
                    </th>
                    <th
                      class="text-uppercase text-dark text-xxs font-weight-bolder text-center w-1"
                    >
                      Created At
                    </th>
                  </tr>
                </thead>
                <tbody v-if="table.data.length > 0">
                  <tr v-for="type in table.data" :key="type.id">
                    <td
                      class="text-sm py-3 px-4 value-table-wrapped"
                      style="max-width: 6cm"
                    >
                      <div>{{ type.vendor_id }}</div>
                    </td>
                    <td
                      class="text-sm py-3 px-4 value-table-wrapped"
                      style="max-width: 10cm"
                    >
                      <div>{{ type.vendor_name }}</div>
                    </td>
                    <td
                      class="text-sm py-3 px-4 value-table-wrapped"
                      style="max-width: 10cm"
                    >
                      <div>{{ type.contact_person }}</div>
                    </td>
                    <td
                      class="text-sm py-3 px-4 value-table-wrapped"
                      style="max-width: 10cm"
                    >
                      <div>{{ type.email }}</div>
                    </td>
                    <td
                      class="text-sm py-3 px-4 value-table-wrapped"
                      style="max-width: 10cm"
                    >
                      <div>{{ type.phone }}</div>
                    </td>
                    <td
                      class="text-sm py-3 px-4 value-table-wrapped"
                      style="max-width: 10cm"
                    >
                      <div>{{ type.address }}</div>
                    </td>
                    <td
                      class="text-sm py-3 px-4 value-table-wrapped"
                      style="max-width: 10cm"
                    >
                      <div>{{ type.city }}</div>
                    </td>
                    <td
                      class="text-sm py-3 px-4 value-table-wrapped"
                      style="max-width: 10cm"
                    >
                      <div>{{ type.country }}</div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="text-center">
                    <td colspan="3">No Data</td>
                  </tr>
                </tbody>
              </table>

              <SkeletonLoading
                v-else
                class="px-4 pt-5"
                :shapes="[
                  { type: 'line', width: '100%', height: '20px' },
                  { type: 'line', width: '80%', height: '20px' },
                  { type: 'line', width: '60%', height: '20px' },
                ]"
              />
            </div>
            <div class="card-footer pb-0">
              <span class="float-start">
                <BasePagination
                  v-model="table.page.current_pages"
                  :page-count="table.page.total_pages"
                  size="sm"
                  @click="changePage()"
                />
              </span>
              <span class="float-end">
                {{
                  (table.page.current_pages - 1) * table.page.per_pages +
                  table.data.length
                }}
                of {{ table.total }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasePagination from "@/components/BasePagination.vue";
import SkeletonLoading from "@/components/SkeletonLoading.vue";
import moment from "moment";
import api from "@/helpers/api";
import glAccountService from "@/services/generalMasterData/glAccountService"; // Sesuaikan dengan path service

export default {
  components: {
    BasePagination,
    SkeletonLoading,
  },
  data() {
    return {
      loadTimeout: null,
      table: {
        onLoad: false,
        search: this.$route.query.code || "", // Mengambil nilai pencarian dari query
        total: 0,
        data: [
            {
                "vendor_id": "V001",
                "vendor_name": "PT. Sumber Jaya",
                "contact_person": "Budi Santoso",
                "email": "budi@sumberjaya.co.id",
                "phone": "+62 812-3456-7890",
                "address": "Jl. Merdeka No. 10, Jakarta",
                "city": "Jakarta",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V002",
                "vendor_name": "CV. Makmur Abadi",
                "contact_person": "Rina Wijaya",
                "email": "rina@makmurabadi.com",
                "phone": "+62 813-9876-5432",
                "address": "Jl. Sudirman No. 25, Surabaya",
                "city": "Surabaya",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V003",
                "vendor_name": "PT. Sentosa Bersama",
                "contact_person": "Andi Prasetyo",
                "email": "andi@sentosabersama.id",
                "phone": "+62 811-2233-4455",
                "address": "Jl. Gajah Mada No. 8, Bandung",
                "city": "Bandung",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V004",
                "vendor_name": "UD. Sejahtera",
                "contact_person": "Dewi Anggraini",
                "email": "dewi@udsejahtera.com",
                "phone": "+62 812-3344-5566",
                "address": "Jl. Diponegoro No. 14, Yogyakarta",
                "city": "Yogyakarta",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V005",
                "vendor_name": "PT. Mitra Usaha",
                "contact_person": "Surya Mahendra",
                "email": "surya@mitrausaha.co.id",
                "phone": "+62 817-5678-9012",
                "address": "Jl. Pahlawan No. 45, Medan",
                "city": "Medan",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V006",
                "vendor_name": "PT. Cahaya Gemilang",
                "contact_person": "Fitri Haryani",
                "email": "fitri@cahayagemilang.com",
                "phone": "+62 819-2222-3333",
                "address": "Jl. Ahmad Yani No. 32, Semarang",
                "city": "Semarang",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V007",
                "vendor_name": "CV. Indo Makmur",
                "contact_person": "Agus Saputra",
                "email": "agus@indomakmur.id",
                "phone": "+62 815-6789-0123",
                "address": "Jl. Pemuda No. 20, Palembang",
                "city": "Palembang",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V008",
                "vendor_name": "PT. Sukses Bersama",
                "contact_person": "Wati Rahayu",
                "email": "wati@suksesbersama.com",
                "phone": "+62 818-9999-8888",
                "address": "Jl. Jenderal Sudirman No. 99, Makassar",
                "city": "Makassar",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V009",
                "vendor_name": "UD. Maju Lancar",
                "contact_person": "Hadi Setiawan",
                "email": "hadi@majulancar.co.id",
                "phone": "+62 816-4444-7777",
                "address": "Jl. Kartini No. 11, Malang",
                "city": "Malang",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V010",
                "vendor_name": "PT. Global Sentosa",
                "contact_person": "Dian Kurniawan",
                "email": "dian@globalsentosa.com",
                "phone": "+62 812-1111-2222",
                "address": "Jl. Sudirman No. 5, Pekanbaru",
                "city": "Pekanbaru",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V011",
                "vendor_name": "PT. Indo Jaya Perkasa",
                "contact_person": "Rizky Ananda",
                "email": "rizky@indojayaperkasa.com",
                "phone": "+62 819-7777-6666",
                "address": "Jl. Diponegoro No. 78, Denpasar",
                "city": "Denpasar",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V012",
                "vendor_name": "CV. Amanah Sejahtera",
                "contact_person": "Siti Aminah",
                "email": "siti@amanahsejahtera.com",
                "phone": "+62 818-5555-4444",
                "address": "Jl. Veteran No. 12, Balikpapan",
                "city": "Balikpapan",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V013",
                "vendor_name": "PT. Prima Jaya",
                "contact_person": "Aditya Nugroho",
                "email": "aditya@primajaya.co.id",
                "phone": "+62 811-6666-5555",
                "address": "Jl. Gatot Subroto No. 21, Manado",
                "city": "Manado",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V014",
                "vendor_name": "UD. Harmoni",
                "contact_person": "Teguh Santoso",
                "email": "teguh@udharmoni.com",
                "phone": "+62 817-3333-2222",
                "address": "Jl. Thamrin No. 19, Samarinda",
                "city": "Samarinda",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V015",
                "vendor_name": "PT. Berkah Mandiri",
                "contact_person": "Yusuf Rahman",
                "email": "yusuf@berkahmandiri.com",
                "phone": "+62 813-8888-7777",
                "address": "Jl. Sudirman No. 55, Banda Aceh",
                "city": "Banda Aceh",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V016",
                "vendor_name": "CV. Mulia Sejahtera",
                "contact_person": "Nina Sari",
                "email": "nina@muliaserahtera.com",
                "phone": "+62 816-2222-1111",
                "address": "Jl. Pasar Baru No. 8, Pontianak",
                "city": "Pontianak",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V017",
                "vendor_name": "PT. Mega Sentosa",
                "contact_person": "Ahmad Fauzi",
                "email": "ahmad@megasentosa.com",
                "phone": "+62 819-4444-3333",
                "address": "Jl. Dipatiukur No. 30, Palu",
                "city": "Palu",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V018",
                "vendor_name": "UD. Karya Utama",
                "contact_person": "Lina Pramesti",
                "email": "lina@karyautama.co.id",
                "phone": "+62 815-6666-9999",
                "address": "Jl. Asia Afrika No. 77, Kendari",
                "city": "Kendari",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V019",
                "vendor_name": "PT. Nusantara Abadi",
                "contact_person": "Fajar Wibowo",
                "email": "fajar@nusantaraabadi.com",
                "phone": "+62 812-7777-8888",
                "address": "Jl. Sultan Agung No. 4, Jayapura",
                "city": "Jayapura",
                "country": "Indonesia"
            },
            {
                "vendor_id": "V020",
                "vendor_name": "CV. Sinar Baru",
                "contact_person": "Rahmad Hidayat",
                "email": "rahmad@sinarbaru.com",
                "phone": "+62 818-3333-4444",
                "address": "Jl. Cendrawasih No. 11, Ternate",
                "city": "Ternate",
                "country": "Indonesia"
            }
        ]
,
        page: {
          current_pages: 1,
          per_pages: 100, // Tambahkan sesuai kebutuhan
        },
      },
    };
  },
  watch: {
    "table.page.current_pages": {
      handler() {
        this.get();
      },
    },
  },
  mounted() {
    // this.get();
  },
  methods: {
    async get() {
      this.table.onLoad = true;

      try {
        const response = await api(
          this,
          glAccountService.list(this.table.page.current_pages, {
            code: this.table.search,
          }),
          false
        );

        this.table.data = response.data.data;
        this.table.total = response.data.total_items;
        this.table.page = response.data;
      } catch (error) {
        this.table.data = [];
        this.table.total = 0;
      } finally {
        this.table.onLoad = false;
      }
    },
    filter() {
      clearTimeout(this.loadTimeout);
      this.loadTimeout = setTimeout(() => {
        this.updateQuery(); // Memperbarui URL
        this.get();
      }, 300);
    },
    updateQuery() {
      this.$router.push({ query: { code: this.table.search } });
    },
    changePage() {
      this.get();
    },
    formatDate(date) {
      return moment(date).format("DD MMMM YYYY, HH:mm");
    },
  },
};
</script>

<style scoped>
/* Tambahkan styling sesuai kebutuhan */
</style>
